$(document).ready(function () {
  $(".itg_featured_slides").owlCarousel({
    loop: true,
    margin: 30,
    dots: false,
    nav: true,
    navText: [
      '<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0001 24.6305L1.00012 12.6305L13.0001 0.630493" stroke="#313132" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 24.6305L13 12.6305L1 0.630493" stroke="#313132" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        margin: 10,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  });

  $(".icnt_list").owlCarousel({
    loop: true,
    margin: 0,
    dots: false,
    nav: true,
    navText: [
      '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75012 16.5869L1.25012 9.08691L8.75012 1.58691" stroke="#313132" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5869L8.75 9.08691L1.25 1.58691" stroke="#313132" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsiveClass: true,
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  });

  $(".itg_multicolum_slides").owlCarousel({
    loop: true,
    margin: 0,
    dots: true,
    nav: true,
    navText: [
      '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75012 16.5869L1.25012 9.08691L8.75012 1.58691" stroke="#313132" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5869L8.75 9.08691L1.25 1.58691" stroke="#313132" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  });

  $(".accordian_slider_data").owlCarousel({
    loop: true,
    margin: 0,
    dots: true,
    nav: true,
    navText: [
      '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75012 16.5869L1.25012 9.08691L8.75012 1.58691" stroke="#313132" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5869L8.75 9.08691L1.25 1.58691" stroke="#313132" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  $(".imagetext_slider_data").owlCarousel({
    loop: true,
    margin: 0,
    autoplay:true,
    dots: true,
    nav: true,
    navText: [
      '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75012 16.5869L1.25012 9.08691L8.75012 1.58691" stroke="#313132" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5869L8.75 9.08691L1.25 1.58691" stroke="#313132" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  var Animation = function (animationBar, percentage) {
    this.animationBar = animationBar;
    this.percentage = percentage;
    this.animationArray = null;
    this.animationOffset = null;
    this.labelArray = null;
    this.percentageArray = null;
    this.index = 0;

    this.initialize();
  };

  Animation.prototype.initialize = function () {
    this.animationArray = document.getElementsByClassName(this.percentage);

    if (this.animationOffset === null) this.animationOffset = [];

    if (this.labelArray === null) this.labelArray = [];

    if (this.percentageArray === null) this.percentageArray = [];

    this.setUpElements();
  };

  Animation.prototype.setUpElements = function () {
    for (var i = 0; i < this.animationArray.length; i++) {
      var elem = this.animationArray[i],
        offset =
          elem.offsetTop +
          document.getElementsByClassName(this.percentage)[0].clientHeight,
        percentage = $(this.animationArray[i]).data(this.percentage);

      this.animationOffset.push(offset + 1000);
      this.percentageArray.push(percentage);

      $(this.animationArray[i])
        .find(".label")
        .html(percentage + "%");
    }

    this.attachListeners();
  };

  Animation.prototype.attachListeners = function () {
    $(window).on("scroll", this.onWindowScroll.bind(this));
  };

  Animation.prototype.onWindowScroll = function () {
    for (var i = 0; i < this.animationArray.length; i++) {
      if (
        window.pageYOffset >=
        this.animationOffset[this.index] - window.innerHeight
      ) {
        this.showElement();
        this.index++;
      } else return;
    }
  };

  Animation.prototype.showElement = function () {
    var element = document.getElementsByClassName(this.percentage)[this.index];
    element.className += " show";
    setTimeout(function () {
      $("span.changing_text").delay(4000).text("2").fadeIn(1000);
    }, 600);
    setTimeout(function () {
      $("span.changing_text").delay(7000).text("3").fadeIn(1000);
    }, 1200);
    this.animateBar(element, this.percentageArray[this.index]);
  };

  Animation.prototype.animateBar = function (element, width) {
    var $element = $(element),
      className = " p" + width;

    $element.find(this.animationBar).addClass(className);
  };

  new Animation(".animation-bar", "percentage");

  $(window).one("scroll", function () {
  
    scroll = $(window).scrollTop();
    const  el = $(".itg-water-heat-recovery .animated_word_changer_main");
     // console.log(el.position().top);
    var bottom = el.position().top + el.outerHeight(true);
  
    if (scroll => 800) {
      $(".count").each(function () {
        $(this)
          .prop("Counter", 0)
          .animate(
            {
              Counter: $(this).text(),
            },
            {
              duration: 4000,
              easing: "swing",
              step: function (now) {
                $(this).text(Math.ceil(now));
              },
            }
          );
      });
    }
  });

  $(".itg_article_main a").click(function () {
    $("html, body").animate(
      {
        scrollTop: $($(this).attr("href")).offset().top - 50,
      },
      500
    );
    return false;
  });

 $(".pro_count").each(function (){
    $(this)
      .prop("Counter", 0)
      .animate(
        {
          Counter: $(this).text(),
        },
        {
          duration: 4000,
          easing: "swing",
          step: function (now){
            $(this).text(Math.ceil(now));
          },
        }
    );
});

$('.pro_count_reverse').each(function () {
    $(this).prop('Counter',100).animate({
       Counter: $(this).text()
    }, {
        duration: 4000,
        easing: 'swing',
      animationDirection  : 'reverse',
        step: function (now) {
            $(this).text(Math.ceil(now));
        }
    });
});


//popup js start

 $(document).on("click", ".video_playicon", function() {
     $('.pop_youtube_videos').show();
     $('body').addClass('popup_on');
      });
    $(document).on("click", "span.close_popup_video", function() {
       $('body').removeClass('popup_on');
     $('.pop_youtube_videos').hide();
      });
  $(document).on("click", "body.popup_on", function() {
     $('.pop_youtube_videos').hide();
    $(this).removeClass('popup_on');
 });
  
  var get_store =  localStorage.getItem('popshow');
  if(get_store == null){
    $(document).find(".itg_bg_overlay,#popup1").removeClass('hide_popup');
  }
  $(document).on("click","#popup1 .close",function() {
      $(document).find(".itg_bg_overlay,#popup1").addClass('hide_popup');
  });

$(document).on("click",".language_index ",function() {
    localStorage.removeItem("countrysel");
    var origin   = window.location.origin;  
    var url_after = window.location.pathname;
    var location_name = $(document).find("html").attr('cus_lang');
    localStorage.removeItem("popshow");
    if(location_name == '/'){
      
        if(url_after.indexOf('/en-ca') != -1){
           var alteredURL = url_after.replace('/en-ca','');
         }else if(url_after.indexOf('/fr-ca') != -1){
           var alteredURL = url_after.replace('/fr-ca','');
         }else{
           var alteredURL = url_after;
         }
      
       if(alteredURL.indexOf('pages') != -1){
          var item_url = alteredURL.split('pages/')[1];
          var item_url = item_url.replace('fr-', '');
          var new_url = origin+'/pages/'+item_url;
          window.location.assign(new_url);
       }else{
         var new_url = origin+alteredURL;
         window.location.assign(new_url);
       }
    }
    if(location_name == '/en-ca'){
      
        if(url_after.indexOf('/en-ca') != -1){
           var alteredURL = url_after.replace('/en-ca','');
         }else if(url_after.indexOf('/fr-ca') != -1){
           var alteredURL = url_after.replace('/fr-ca','');
         }else{
           var alteredURL = url_after;
         }
      
       if(alteredURL.indexOf('pages') != -1){
          var item_url = alteredURL.split('pages/')[1];
          var item_url = item_url.replace('fr-', '');
          var new_url = origin+'/'+location_name+'/pages/'+item_url;
          window.location.assign(new_url);
       }else{
         var new_url = origin+'/'+location_name+''+alteredURL;
         window.location.assign(new_url);
       }
    }
    if(location_name == '/fr-ca'){
      
         if(url_after.indexOf('/en-ca') != -1){
           var alteredURL = url_after.replace('/en-ca','');
         }else if(url_after.indexOf('/fr-ca') != -1){
           var alteredURL = url_after.replace('/fr-ca','');
         }else{
           var alteredURL = url_after;
         }
       if(alteredURL.indexOf('pages') != -1){
          var item_url = alteredURL.split('pages/')[1];
          //var item_url = item_url.replace('fr-', '');
          var new_url = origin+'/'+location_name+'/pages/'+item_url;
          window.location.assign(new_url);
       }else{
         var new_url = origin+'/'+location_name+''+alteredURL;
        window.location.assign(new_url);
       }
    }
});

  if((window.location.href.indexOf("en-ca") > -1) || (window.location.href.indexOf("fr-ca") > -1)){
        var countrysel_check = localStorage.getItem("countrysel");
        if(countrysel_check == null){
          var checkcountry = 'CA';
          $("ul#FooterCountryList li a").removeClass('disclosure__link--active');
          $("ul#FooterCountryList li a").each(function(){
              var findcounty = $(this).attr('data-value');
              if(findcounty == checkcountry){
                localStorage.setItem('countrysel','cheked');
                $(this).addClass('disclosure__link--active');
                $(this)[0].click();
              }
          });
        }
  }
  
    if (window.location.href.indexOf("en-ca") > -1) {
      $("#canada_len").attr('checked', true);
    }
    if (window.location.href.indexOf("fr-ca") > -1) {
        $("#frence_len").attr('checked', true);
    }

    var locationpathname = window.location.pathname;
    if(locationpathname.indexOf('pages') != -1){
      var item_url = locationpathname.split('pages/')[1];
      var item_url = item_url.replace('fr-', '');
      var item_urlfirst = locationpathname.split('pages/')[0];
      var new_url = item_urlfirst+'pages/'+item_url;
      if(item_urlfirst != '/'){
        $("ul.list-menu.list-menu--inline li a").each(function(){
           var ths_link = $(this).attr('href');
           if(ths_link == new_url){
             $(this).addClass('current_active_menu ');
           }
        });
      }else{
        var new_url = '/pages/'+item_url;
        $("ul.list-menu.list-menu--inline li a").each(function(){
           var ths_link = $(this).attr('href');
           if(ths_link == new_url){
             $(this).addClass('current_active_menu ');
           }
        });
        
      }
    }else{
        $("ul.list-menu.list-menu--inline li a").each(function(){
           var ths_link = $(this).attr('href');
           if(ths_link == locationpathname){
             $(this).addClass('current_active_menu ');
           }
        });
    }
  
$(document).on("click","#location_btn_redirect",function() {

    localStorage.removeItem("countrysel");
    var origin   = window.location.origin;
    var url_after = window.location.pathname;
    var location_name = $("input[name='fav_language']:checked").val();
    localStorage.setItem('popshow', 'hide_popup');
    if(location_name == 'usa-inter'){
      
         if(url_after.indexOf('/en-ca') != -1){
           var alteredURL = url_after.replace('/en-ca','');
         }else if(url_after.indexOf('/fr-ca') != -1){
           var alteredURL = url_after.replace('/fr-ca','');
         }else{
           var alteredURL = url_after;
         }
      
         if(alteredURL.indexOf('pages') != -1){
            var item_url = alteredURL.split('pages/')[1];
            var item_url = item_url.replace('fr-', '');
            var new_url = origin+'/pages/'+item_url;
            window.location.assign(new_url);
         }else{
           var new_url = origin+alteredURL;
           window.location.assign(new_url);
         }
    }
  
    if(location_name == 'en-ca'){
      
        if(url_after.indexOf('/en-ca') != -1){
           var alteredURL = url_after.replace('/en-ca','');
         }else if(url_after.indexOf('/fr-ca') != -1){
           var alteredURL = url_after.replace('/fr-ca','');
         }else{
           var alteredURL = url_after;
         }
       if(alteredURL.indexOf('pages') != -1){
          var item_url = alteredURL.split('pages/')[1];
          var item_url = item_url.replace('fr-', '');
          var new_url = origin+'/'+location_name+'/pages/'+item_url;
          window.location.assign(new_url);
       }else{
         var new_url = origin+'/'+location_name+''+alteredURL;
         window.location.assign(new_url);
       }
    }
  
    if(location_name == 'fr-ca'){
      
         if(url_after.indexOf('/en-ca') != -1){
           var alteredURL = url_after.replace('/en-ca','');
         }else if(url_after.indexOf('/fr-ca') != -1){
           var alteredURL = url_after.replace('/fr-ca','');
         }else{
           var alteredURL = url_after;
         }
       if(alteredURL.indexOf('pages') != -1){
          var item_url = alteredURL.split('pages/')[1];
          var new_url = origin+'/'+location_name+'/pages/'+item_url;
          window.location.assign(new_url);
       }else{
         var new_url = origin+'/'+location_name+''+alteredURL;
         window.location.assign(new_url);
       }
    }

});


});


